import PropTypes from 'prop-types';

export default PropTypes.oneOfType([
  PropTypes.bool,
  PropTypes.shape({
    url: PropTypes.string,
    redirect: PropTypes.bool,
    radius: PropTypes.bool,
    playsInline: PropTypes.bool,
    autoplay: PropTypes.bool,
    topViewportOffset: PropTypes.string,
    playpriority: PropTypes.string,
  }),
]);
